import React, { Component } from "react";
import { MDBModal, MDBModalHeader, MDBModalBody, MDBModalFooter } from "mdbreact";
import axios from "axios";
import MetaTags from "react-meta-tags";
import packkagee from "../../package.json";
import Swal from "sweetalert2";
import { Button, Image, Pane, Text } from "evergreen-ui";
import { HiDocumentText } from "react-icons/hi";
import present1 from "../assets/present2568/1.png";
import present2 from "../assets/present2568/2.jpg";
import present3 from "../assets/present2568/3.png";
import present4 from "../assets/present2568/4.png";
import present5 from "../assets/present2568/5.png";
import present6 from "../assets/present2568/6.png";
import present7 from "../assets/present2568/7.png";
import present8 from "../assets/present2568/8.png";
import present9 from "../assets/present2568/9.png";
import present10 from "../assets/present2568/10.png";
import present11 from "../assets/present2568/11.png";
import present12 from "../assets/present2568/12.png";
import present13 from "../assets/present2568/13.png";
import present14 from "../assets/present2568/14.png";
import present15 from "../assets/present2568/15.png";
import present16 from "../assets/present2568/16.png";
import present17 from "../assets/present2568/17.png";
import present18 from "../assets/present2568/18.png";
import present19 from "../assets/present2568/19.png";
import present20 from "../assets/present2568/20.png";
import present21 from "../assets/present2568/21.png";
import present22 from "../assets/present2568/22.png";
import present23 from "../assets/present2568/23.png";
import present24 from "../assets/present2568/24.png";
import present25 from "../assets/present2568/25.png";
import present26 from "../assets/present2568/26.png";
import present27 from "../assets/present2568/27.png";
import present28 from "../assets/present2568/28.png";
import { admission } from "./ADMISSION";
import { mua } from "./MUA";
export default class Checkpresent extends Component {
  constructor(props) {
    super(props);
    this.state = {
      citizent: "",
      checkpaymoney: false,
      screenWidth: 0,
      screenHieght: 0,
      present: false,
      load: false,
      // pathreturn: "http://localhost:3000/admission",
      pathreturn: "https://admission.kpru.ac.th/admission",
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSubmit = this.handleSubmit.bind(this);
    this.checkpaymoney_close = this.checkpaymoney_close.bind(this);
    this.CheckDatePresent = this.CheckDatePresent.bind(this);
    this.submitpresent2025 = this.submitpresent2025.bind(this);
    this.checkpdpa = this.checkpdpa.bind(this);
  }
  redirectToDataRegister = (item) => {
    // ใช้ history.push เพื่อเปลี่ยนเส้นทาง
    window.location.href = this.state.pathreturn + item;
  };
  CheckDatePresent() {
    const starts = "2025-04-01 00:00";
    const start = new Date(starts);
    const stops = "2025-04-30 16:40";
    const stop = new Date(stops);
    // console.log(start)
    // console.log(stop)
    const date = new Date();
    // console.log(date)
    if (date >= start && date <= stop) {
      /// true เท่ากับเปิด
      this.setState({ present: true });
    } else {
      // console.log("ปิด")
      /// false เท่ากับปิด
      // this.setState({ present: false });
      this.setState({ present: true });
    }
  }
  componentDidMount() {
    localStorage.clear();
    this.CheckDatePresent();
    if (window.screen.width < 500) {
      this.setState({ screenWidth: "100%" });
    } else {
      this.setState({ screenWidth: window.screen.width * 0.3 });
    }
    this.setState({ screenHieght: window.screen.height });
  }

  handleChange(event) {
    event.preventDefault();
    this.setState({ [event.target.name]: event.target.value });
  }

  handleSubmit(event) {
    event.preventDefault();
    this.state.citizent = this.state.citizent.replace("/", ",");
    axios
      .get(
        "https://mua.kpru.ac.th/FrontEnd_Admission/admissionnew2022/showlistregister?id=" +
        this.state.citizent
      )
      .then((res) => {
        if (res.data.data.data.length !== 0) {
          // Swal.fire({
          //   icon: "success",
          //   title: "ยินดีต้อนรับ",
          //   timer:1500,
          //   timerProgressBar:true,
          //   showConfirmButton:false
          // }).then((res)=>{
          // Swal.fire({
          //   icon:'info'
          // }).then((res)=>{

          // })
          res.data.data.data = res.data.data.data.filter(
            ({ REGISTER_STATUS }) =>
              !(
                REGISTER_STATUS === "11" ||
                REGISTER_STATUS === "91" ||
                REGISTER_STATUS === "12" ||
                REGISTER_STATUS === "5" ||
                REGISTER_STATUS === "41"
              )
          );
          // res.data.data.data = res.data.data.data.filter(({ REGISTER_STATUS }) => parseInt(REGISTER_STATUS) >= 4 );
          console.log(res.data.data.data);
          if (
            res.data.data.data[0]["REGISTER_STATUS"] === "0" ||
            res.data.data.data[0]["REGISTER_STATUS"] === "1" ||
            res.data.data.data[0]["REGISTER_STATUS"] === "2" ||
            res.data.data.data[0]["REGISTER_STATUS"] === "3" ||
            res.data.data.data[0]["REGISTER_STATUS"] === "4" ||
            res.data.data.data[0]["REGISTER_STATUS"] === "5" ||
            res.data.data.data[0]["REGISTER_STATUS"] === "12"
          ) {
            localStorage.setItem("citizent", this.state.citizent);
            localStorage.setItem("ID_LOGIN", res.data.data.data[0]["ID_LOGIN"]);
            // localStorage.setItem("statusHeader", "1");
            localStorage.setItem("statustitle", "ตรวจสอบสถานะ");
            axios
              .get(
                "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                this.state.citizent +
                "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
              )
              .then((checkdata) => {
                if (checkdata.data.length !== 0) {
                  Swal.fire({
                    icon: "success",
                    title: "ยินดีต้อนรับ",
                    timer: 1500,
                    timerProgressBar: true,
                    showConfirmButton: false,
                  }).then((res) => {
                    window.location.href = "/" + packkagee.name + "/Dataregister";
                  });
                } else {
                  Swal.fire({
                    icon: "success",
                    title: "ยินดีต้อนรับ",
                    timer: 1500,
                    timerProgressBar: true,
                    showConfirmButton: false,
                  }).then((res) => {
                    window.location.href =
                      "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                      btoa(this.state.citizent) +
                      "&status=" +
                      btoa(3) +
                      "&url=" +
                      btoa(window.location.origin + "/" + packkagee.name + "/Dataregister");
                  });
                }
                // }
              });
          } else if (
            res.data.data.data[0]["REGISTER_STATUS"] === "6" ||
            res.data.data.data[0]["REGISTER_STATUS"] === "7" ||
            res.data.data.data[0]["REGISTER_STATUS"] === "8" ||
            res.data.data.data[0]["REGISTER_STATUS"] === "9"
          ) {
            if (res.data.data.data[0]["REGISTER_TYPE_ID"] === "6") {
              localStorage.setItem("citizent", this.state.citizent);
              localStorage.setItem("ID_LOGIN", res.data.data.data[0]["ID_LOGIN"]);
              localStorage.setItem("statusHeader", "1");
              axios
                .get(admission + "/student/creckprecent1/" + res.data.data.data[0]["REGISTER_ID"])
                .then((response) => {
                  if (response.data === 0) {
                    axios
                      .get(
                        "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                        this.state.citizent +
                        "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                      )
                      .then((checkdata) => {
                        if (checkdata.data.length !== 0) {
                          Swal.fire({
                            icon: "success",
                            title: "ยินดีต้อนรับ",
                            timer: 1500,
                            timerProgressBar: true,
                            showConfirmButton: false,
                          }).then((res) => {
                            window.location.href = "/" + packkagee.name + "/Present";
                          });
                        } else {
                          Swal.fire({
                            icon: "success",
                            title: "ยินดีต้อนรับ",
                            timer: 1500,
                            timerProgressBar: true,
                            showConfirmButton: false,
                          }).then((res) => {
                            window.location.href =
                              "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                              btoa(this.state.citizent) +
                              "&status=" +
                              btoa(3) +
                              "&url=" +
                              btoa(window.location.origin + "/" + packkagee.name + "/Present");
                          });
                        }
                      });
                  } else {
                    axios
                      .get(
                        "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                        this.state.citizent +
                        "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                      )
                      .then((checkdata) => {
                        if (checkdata.data.length !== 0) {
                          Swal.fire({
                            icon: "success",
                            title: "ยินดีต้อนรับ",
                            timer: 1500,
                            timerProgressBar: true,
                            showConfirmButton: false,
                          }).then((res) => {
                            window.location.href = "/" + packkagee.name + "/Present";
                          });
                        } else {
                          Swal.fire({
                            icon: "success",
                            title: "ยินดีต้อนรับ",
                            timer: 1500,
                            timerProgressBar: true,
                            showConfirmButton: false,
                          }).then((res) => {
                            window.location.href =
                              "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                              btoa(this.state.citizent) +
                              "&status=" +
                              btoa(3) +
                              "&url=" +
                              btoa(window.location.origin + "/" + packkagee.name + "/Present");
                          });
                        }
                      });
                  }
                });
            } else if (
              res.data.data.data[0]["REGISTER_TYPE_ID"] === "2" ||
              res.data.data.data[0]["REGISTER_TYPE_ID"] === "3"
            ) {
              localStorage.setItem("citizent", this.state.citizent);
              localStorage.setItem("ID_LOGIN", res.data.data.data[0]["ID_LOGIN"]);
              // if (this.state.present === true) {

              // } else {
              //   // window.location.href = "/" + packkagee.name + "/Dataregister";
              // }

              // เปิดตอนช่วงรายงานตัว
              localStorage.setItem("statusHeader", "1");
              axios
                .get(admission + "/student/creckprecent1/" + res.data.data.data[0]["REGISTER_ID"])
                .then((response) => {
                  if (response.data === 0) {
                    axios
                      .get(
                        "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                        this.state.citizent +
                        "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                      )
                      .then((checkdata) => {
                        if (checkdata.data.length !== 0) {
                          window.location.href = "/" + packkagee.name + "/Present";
                        } else {
                          window.location.href =
                            "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                            btoa(this.state.citizent) +
                            "&status=" +
                            btoa(3) +
                            "&url=" +
                            btoa(window.location.origin + "/" + packkagee.name + "/Present");
                        }
                      });
                  } else {
                    axios
                      .get(
                        "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                        this.state.citizent +
                        "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                      )
                      .then((checkdata) => {
                        if (checkdata.data.length !== 0) {
                          window.location.href = "/" + packkagee.name + "/Present";
                        } else {
                          window.location.href =
                            "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                            btoa(this.state.citizent) +
                            "&status=" +
                            btoa(3) +
                            "&url=" +
                            btoa(window.location.origin + "/" + packkagee.name + "/Present");
                        }
                      });
                  }
                });
            } else {
              localStorage.setItem("citizent", this.state.citizent);
              localStorage.setItem("ID_LOGIN", res.data.data.data[0]["ID_LOGIN"]);
              // Swal.fire({
              //   text: this.state.pathreturn + "/Present",
              // }).then((res) => {
              // });
              // return 0;
              if (this.state.present === true) {
              } else {
                // window.location.href = "/" + packkagee.name + "/Dataregister";
              }

              if (
                // res.data.data.data[0]["Major1_MAJOR_ID"] === "9902" ||
                res.data.data.data[0]["Major1_MAJOR_ID"] === "9903" ||
                res.data.data.data[0]["Major1_MAJOR_ID"] === "9901"
              ) {
                if (
                  res.data.data.data[0]["REGISTER_STATUS_BILL_ROB1_BOOK"] ||
                  res.data.data.data[0]["REGISTER_STATUS_BILL_ROB2_BOOK"] ||
                  res.data.data.data[0]["REGISTER_STATUS_BILL_ROBFULL_BOOK"]
                ) {
                  localStorage.setItem("statusHeader", "1");
                  axios
                    .get(
                      admission + "/student/creckprecent1/" + res.data.data.data[0]["REGISTER_ID"]
                    )
                    .then((response) => {
                      if (response.data === 0) {
                        axios
                          .get(
                            "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                            this.state.citizent +
                            "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                          )
                          .then((checkdata) => {
                            if (checkdata.data.length !== 0) {
                              window.location.href = this.state.pathreturn + "/Present";
                            } else {
                              window.location.href =
                                "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                                btoa(this.state.citizent) +
                                "&status=" +
                                btoa(3) +
                                "&url=" +
                                btoa(this.state.pathreturn + "/Present");
                            }
                          });
                      } else {
                        axios
                          .get(
                            "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                            this.state.citizent +
                            "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                          )
                          .then((checkdata) => {
                            if (checkdata.data.length !== 0) {
                              window.location.href = this.state.pathreturn + "/Present";
                            } else {
                              window.location.href =
                                "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                                btoa(this.state.citizent) +
                                "&status=" +
                                btoa(3) +
                                "&url=" +
                                btoa(this.state.pathreturn + "/Present");
                            }
                          });
                      }
                    });
                } else {
                  this.setState({ checkpaymoney: true });
                }
              } else {
                if (
                  res.data.data.data[0]["REGISTER_STATUS_BILL_ROBFULL_BOOK"] ||
                  res.data.data.data[0]["REGISTER_ID"] === "6708204012"
                ) {
                  localStorage.setItem("statusHeader", "1");
                  axios
                    .get(
                      admission + "/student/creckprecent1/" + res.data.data.data[0]["REGISTER_ID"]
                    )
                    .then((response) => {
                      if (response.data === 0) {
                        axios
                          .get(
                            "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                            this.state.citizent +
                            "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                          )
                          .then((checkdata) => {
                            if (checkdata.data.length !== 0) {
                              window.location.href = this.state.pathreturn + "/Present";
                            } else {
                              window.location.href =
                                "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                                btoa(this.state.citizent) +
                                "&status=" +
                                btoa(3) +
                                "&url=" +
                                btoa(this.state.pathreturn + "/Present");
                            }
                          });
                      } else {
                        axios
                          .get(
                            "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                            this.state.citizent +
                            "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                          )
                          .then((checkdata) => {
                            if (checkdata.data.length !== 0) {
                              window.location.href = this.state.pathreturn + "/Present";
                            } else {
                              window.location.href =
                                "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                                btoa(this.state.citizent) +
                                "&status=" +
                                btoa(3) +
                                "&url=" +
                                btoa(this.state.pathreturn + "/Present");
                            }
                          });
                      }
                    });
                } else if (res.data.data.data[0]["REGISTER_STATUS_BILL_ROB1_BOOK"]) {
                  if (res.data.data.data[0]["REGISTER_STATUS_BILL_ROB2_BOOK"]) {
                    localStorage.setItem("statusHeader", "1");
                    axios
                      .get(
                        admission + "/student/creckprecent1/" + res.data.data.data[0]["REGISTER_ID"]
                      )
                      .then((response) => {
                        if (response.data === 0) {
                          axios
                            .get(
                              "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                              this.state.citizent +
                              "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                            )
                            .then((checkdata) => {
                              if (checkdata.data.length !== 0) {
                                window.location.href = this.state.pathreturn + "/Present";
                              } else {
                                window.location.href =
                                  "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                                  btoa(this.state.citizent) +
                                  "&status=" +
                                  btoa(3) +
                                  "&url=" +
                                  btoa(window.location.origin + this.state.pathreturn + "/Present");
                              }
                            });
                        } else {
                          axios
                            .get(
                              "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
                              this.state.citizent +
                              "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
                            )
                            .then((checkdata) => {
                              if (checkdata.data.length !== 0) {
                                window.location.href = this.state.pathreturn + "/Present";
                              } else {
                                window.location.href =
                                  "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
                                  btoa(this.state.citizent) +
                                  "&status=" +
                                  btoa(3) +
                                  "&url=" +
                                  btoa(this.state.pathreturn + "/Present");
                              }
                            });
                        }
                      });
                  } else {
                    this.setState({ checkpaymoney: true });
                  }
                } else {
                  this.setState({ checkpaymoney: true });
                }
              }
            }
          }
          // })
        } else {
          Swal.fire({
            icon: "warning",
          });
        }
      });
  }

  checkpaymoney_close(event) {
    this.setState({ checkpaymoney: false });
  }
  checkpdpa(citizent) {
    localStorage.setItem("statusHeader", "1");
    axios
      .get(
        "https://arit.kpru.ac.th/ap/account/api.php?nu=pdpaGET&field=code&fieldValue=" +
        citizent +
        "&Token=S2FtcGhhZW5nIFBoZXQgUmFqYWJoYXQgVW5pdmVyc2l0eQ%3D%3D"
      )
      .then((response) => {
        if (response.data.length !== 0) {
          Swal.fire({
            icon: "success",
            title: "ยินดีต้อนรับ",
            timer: 1500,
            timerProgressBar: true,
            showConfirmButton: false,
          }).then((res) => {
            this.redirectToDataRegister("/Present");
          });
        } else {
          Swal.fire({
            icon: "success",
            title: "ยินดีต้อนรับ",
            timer: 1500,
            timerProgressBar: true,
            showConfirmButton: false,
          }).then((res) => {
            window.location.href =
              "https://arit.kpru.ac.th/ap/account/?nu=pdpaAgree&code=" +
              btoa(this.state.citizent) +
              "&status=" +
              btoa(3) +
              "&url=" +
              btoa(this.state.pathreturn + "/Present");
          });
        }
      });
  }
  submitpresent2025(event) {
    this.setState({ load: true });
    event.preventDefault();
    localStorage.setItem("citizent", this.state.citizent);

    this.state.citizent = this.state.citizent.replace("/", ",");
    // window.location.href = this.state.pathreturn + "/Dataregister";
    axios
      .get(mua + "/admissionnew2022/showlistregister?id=" + this.state.citizent)
      .then((response) => {
        this.setState({ load: false });
        const data = response.data.data.data;
        if (data.length !== 0) {
          localStorage.setItem("ID_LOGIN", data[0].ID_LOGIN);
        }
        const datatrue = data.filter(
          ({ REGISTER_STATUS }) =>
            REGISTER_STATUS === "4" ||
            REGISTER_STATUS === "6" ||
            REGISTER_STATUS === "7" ||
            REGISTER_STATUS === "8" ||
            REGISTER_STATUS === "9"
        );
        if (datatrue.length === 0) {
          // window.location.href = this.state.pathreturn + "/Dataregister";
        } else {
          if (datatrue[0].REGISTER_STATUS_BILL_ROBFULL_BOOK !== null) {
            this.checkpdpa(this.state.citizent);
          } else if (
            (datatrue[0].REGISTER_STATUS_BILL_ROB1_BOOK !== null &&
              datatrue[0].REGISTER_STATUS_BILL_ROB2_BOOK !== null) ||
            (datatrue[0].REGISTER_STATUS_BILL_ROB1_BOOK !== null &&
              (datatrue[0].Major1_MAJOR_ID === "9903" || datatrue[0].Major1_MAJOR_ID === "9901")) || (datatrue[0].Major1_MAJOR_ID === "8205")
          ) {
            this.checkpdpa(this.state.citizent);
          } else {
            Swal.fire({
              icon: "info",
              html: "<div style='display:flex;flex-direction:column;' ><div style='font-weight:500;font-size:20px;' >ชำระเงินค่าธรรมเนียมทางการศึกษายังไม่ครบถ้วน</div><div style='font-weight:300;font-size:16;'>ยังไม่สามารถกรอกข้อมูลรายงานตัวได้ กรุณาติดต่อ 055-706547</div> </div>",
            }).then((resssssss) => {
              localStorage.setItem("ID_LOGIN", data[0].ID_LOGIN);

              this.redirectToDataRegister("/Dataregister");
            });
          }
        }
        console.log(datatrue);
      });
    // Swal.fire({
    //   icon: "success",
    //   text: this.state.citizent,
    // });
  }
  render() {
    return (
      <>
        <MetaTags>
          <title>ข้อมูลรายงานตัว มหาวิทยาลัยราชภัฏกำแพงเพชร</title>
          <meta
            name="description"
            content="ข้อมูลรายงานตัว มหาวิทยาลัยราชภัฏกำแพงเพชร Kamphaeng Phet Rajabhat University"
          />
          <meta property="og:title" content="ข้อมูลรายงานตัว มหาวิทยาลัยราชภัฏกำแพงเพชร" />
          <meta property="og:image" content="../../public/favicon.ico" />
        </MetaTags>
        <br />
        <Pane className="container-md">
          <Pane
            boxShadow="0px 0px 10px #00000030"
            padding={15}
            marginBottom="20px"
            borderRadius={8}
          >
            <Text
              className="container-fluid my-2 p-2"
              color="#429777"
              fontFamily=""
              fontSize={18}
              fontWeight={500}
              display="flex"
              justifyContent="center"
            >
              ข้อมูลรายงานตัว มหาวิทยาลัยราชภัฏกำแพงเพชร
            </Text>

            <form onSubmit={this.submitpresent2025}>
              <div className="form-outline">
                <input
                  type="text"
                  className="form-control"
                  id="citizent"
                  name="citizent"
                  placeholder="รหัสเลขบัตรประชาชน/เลขบัตร Passport"
                  onChange={this.handleChange}
                  required
                />
              </div>
              <br />
              <div className="form-outline">
                <Button
                  isLoading={this.state.load}
                  width="100%"
                  iconBefore={<HiDocumentText />}
                  type="submit"
                  appearance="primary"
                  intent="success"
                  disabled={this.props.match.params.param !== "bebe"}
                >
                  <Text fontFamily="" color="white">
                    {" "}
                    เริ่มกรอกข้อมูลรายงานตัว
                  </Text>
                </Button>
              </div>
            </form>
          </Pane>
          <div className="d-flex justify-content-center pt-2">
            <Text fontWeight={500} fontSize={24}>
              วีดีโอตัวอย่างขั้นตอนการกรอกข้อมูลรายงานตัว
            </Text>
          </div>
          <div className="text-center mt-2 mb-2">
            <iframe
              width="560"
              height="315"
              src="https://www.youtube.com/embed/6Ewl4uLPq64?autoplay=0&controls=1;"
              title="YouTube video player"
              frameborder="0"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
              referrerpolicy="strict-origin-when-cross-origin"
              allowfullscreen
            ></iframe>
          </div>
          <>
            <div className="container-fluid">
              <Image src={present1} width="100%" />
              <Image src={present2} width="100%" />
              <Image src={present3} width="100%" />
              <Image src={present4} width="100%" />
              <Image src={present5} width="100%" />
              <Image src={present6} width="100%" />
              <Image src={present7} width="100%" />
              <Image src={present8} width="100%" />
              <Image src={present9} width="100%" />
              <Image src={present10} width="100%" />
              <Image src={present11} width="100%" />
              <Image src={present12} width="100%" />
              <Image src={present13} width="100%" />
              <Image src={present14} width="100%" />
              <Image src={present15} width="100%" />
              <Image src={present16} width="100%" />
              <Image src={present17} width="100%" />
              <Image src={present18} width="100%" />
              <Image src={present19} width="100%" />
              <Image src={present20} width="100%" />
              <Image src={present21} width="100%" />
              <Image src={present22} width="100%" />
              <Image src={present23} width="100%" />
              <Image src={present24} width="100%" />
              <Image src={present25} width="100%" />
              <Image src={present26} width="100%" />
              <Image src={present27} width="100%" />
              <Image src={present28} width="100%" />
            </div>
          </>
          {/* <MDBModal
            className="mb-5"
            size="lg"
            isOpen={this.state.checkpaymoney}
            toggle={this.checkpaymoney_close}
            centered
            dark
            closeButton
          >
            <MDBModalHeader toggle={this.checkpaymoney_close}>
              <Text strong style={{ fontSize: "24px" }}>
                {" "}
                แจ้งเตือนการรายงานตัว{" "}
              </Text>
            </MDBModalHeader>
            <MDBModalBody>
              ชำระเงินค่าธรรมเนียมทางการศึกษายังไม่ครบถ้วน ยังไม่สามารถกรอกข้อมูลรายงานตัวได้
              กรุณาติดต่อ 055-706547
            </MDBModalBody>
            <MDBModalFooter>
              <button className="mt-1 btn btn-danger" onClick={this.checkpaymoney_close}>
                ปิด
              </button>
            </MDBModalFooter>
          </MDBModal> */}
        </Pane>
        <br />
      </>
    );
  }
}
